module.exports = __webpack_public_path__ + "img/verbatim-negatif.925e4cd1.svg";